<template>
  <b-form-checkbox
    v-model="selected"
    class="custom-control-danger"
  >
    <strong>
      Ver únicamente la información que no pudo ser validada
    </strong>
  </b-form-checkbox>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  components: {
    BFormCheckbox,
  },
  setup(_, { emit }) {
    const selected = ref(false)

    watch(() => selected.value, newValue => {
      emit('filter-only-no-validated', newValue)
    })

    return {
      selected,
    }
  },
}
</script>
